export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:9000/api/v1";

export const DEFAULT_S3_FILE_BUCKET_URL =
  process.env.REACT_APP_DEFAULT_S3_FILE_BUCKET_URL;

export const DEFAULT_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 0,
  CHOICE: 1,
  INPUT: 2,
  RATING: 3,
  SLIDER: 4,
  EMOJI: 5,
  SLIDER_RATING: 6,
  SLIDER_AGREE_DISAGREE_RATING: 7,
  BEHAVIOUR: 8,
};

export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export const DATE_FORMAT = "YYYY-MM-DD hh:mm A";
